// extracted by mini-css-extract-plugin
export default {"ace-c-contract-partner-item--highlighted":"contract-partner-item--highlighted---9d9e15b8"};